import React from 'react';
import { IBasicLookupFieldProps } from '@markinson/uicomponents-v2/BasicLookupField';
import { IBasicLookupFieldHandle } from '@markinson/uicomponents-v2/BasicLookupField/BasicLookup.properties';
import PickSlipLookup from 'components/common/PickSlipLookup';
interface IScopeOptions {
  isCustomerScoped?: boolean;
  isWarehouseScoped?: boolean;
}

export interface IPickSlipLookupFieldProps extends Omit<IBasicLookupFieldProps, 'valueField' | 'displayField' | 'descriptionField' | 'column1Field' | 'column2Field'>, IScopeOptions {
  params?: any;
  fieldRef?: React.Ref<IBasicLookupFieldHandle>;
  onValueChange?(value: string): void;
  setFieldAsyncError?(fieldName: string, error: string): void;
}

const PickSlipLookupField = (props: Omit<IPickSlipLookupFieldProps, 'classes' | 'onFindOption' | 'onSearch'>, ref: React.Ref<IBasicLookupFieldHandle>) => {

  const {
    fieldRef,
    setFieldAsyncError,
    onSelectedItemChange,
    onChange,
    onValueChange,
    onInvalidChange,
  } = props;

  return (
    <PickSlipLookup
      {...props}
      ref={fieldRef ? fieldRef : ref}
      onSelectedItemChange={(selectedItem: any, searchText) => {
        const productId = selectedItem?.Details?.ProductId ? Number(selectedItem?.Details?.ProductId) : selectedItem?.Code;

        if (onChange) {
          onChange(productId || '');
        }

        if (onSelectedItemChange) {
          onSelectedItemChange(selectedItem, searchText);
        }
      }}
      onInvalidChange={(invalid: boolean, invalidValue) => {
        if (onInvalidChange) {
          onInvalidChange(invalid, invalidValue);
        }
        if (setFieldAsyncError) {
          setFieldAsyncError(props.name, invalid ? 'Invalid Value' : null);
        }
      }}
      onChange={onValueChange} />
  );
};

export default React.memo(React.forwardRef(PickSlipLookupField));
